// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @16/10/2024 15:13:49
import { StatusItems } from '../../SagaStateLib/StatusItems';
import * as SagaStateLib from '../../SagaStateLib';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListCardStatus_abstract extends StatusItems {
  static $t: string = 'SagaStateLib.ListCardStatus';
  $t: string = 'SagaStateLib.ListCardStatus';

  public static GetMembers(): string[] {
    return ['CannotEngage', 'OFColor'].concat(StatusItems.GetMembers());
  }

  public GetMembers(): string[] {
    return ListCardStatus_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public CannotEngage: boolean = false;
  public OFColor: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
